import { Plan } from "@/model/entities";
import { useEffect, useState } from "react";
import * as planService from "@/service/planService";
import { useCurrentRestaurant } from "./useCurrentRestaurant";
import { useCategories } from "@/query/useCategories";
import { useMenuItemsByRestaurant } from "@/query/useMenuItems";

export function usePlan() {
  const { restaurant, restaurantId } = useCurrentRestaurant();
  const { data: categories, isLoading: isLoadingCategories } =
    useCategories(restaurantId);
  const { data: menuItems, isLoading: isLoadingMenuItems } =
    useMenuItemsByRestaurant(restaurantId);

  const [isAllowedToAddCategory, setIsAllowedToAddCategory] =
    useState<boolean>(false);
  const [isAllowedToAddMenuItem, setIsAllowedToAddMenuItem] =
    useState<boolean>(false);
  const [plan, setPlan] = useState<Plan | undefined>(undefined);

  useEffect(() => {
    if (!restaurant) {
      setPlan(undefined);
      setIsAllowedToAddCategory(false);
      setIsAllowedToAddMenuItem(false);
      return;
    }

    setPlan(planService.getPlan(restaurant));
  }, [restaurant]);

  useEffect(() => {
    if (!restaurant || isLoadingCategories) return;

    const currentPlan = planService.getPlan(restaurant);
    setIsAllowedToAddCategory(
      planService.isAllowedToAddCategory(currentPlan, categories?.length ?? 0)
    );
  }, [restaurant, categories, isLoadingCategories]);

  useEffect(() => {
    if (!restaurant || isLoadingMenuItems) return;

    const currentPlan = planService.getPlan(restaurant);
    setIsAllowedToAddMenuItem(
      planService.isAllowedToAddMenuItem(currentPlan, menuItems?.length ?? 0)
    );
  }, [restaurant, menuItems, isLoadingMenuItems]);

  return { isAllowedToAddCategory, plan, isAllowedToAddMenuItem };
}
